import * as React from 'react';
import { ToneCardViewImpl } from '../../home/featuredcategory/viewmodel/tonecard/tonecardview';
import { NameTuneBuyComponent } from '../../popup/nametune/nametunebuycomponent';
import { ToneOptionsType } from '../../popup/tonedetailspopup/tonedetailspopupcomponent';
import { ToneCardComponentProps } from '../../home/featuredcategory/viewmodel/tonecard/tonecardcomponent';

export class NameTuneCardViewImpl extends ToneCardViewImpl
{
    protected onBuyToneClicked():void
    {
        let player = this.getPlayerComponent();
        player !== null && player.onStopClicked();
        this.getPopUpWrapper().setShowWindow(true,
            <NameTuneBuyComponent showPopupOption={this.showToneOptionsPopup} showPopup={this.showPopup} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneCardComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

    // onBuySuccess():void
    // {
    //     this.closePopup();
    //      this.getPopUpWrapper().setShowWindow(true, <AlertComponent buttonTitle={"Ok"} alertMessage={"Your Order completed successfully."} alertType={AlertType.SUCCESS} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunecard/nametunecardview.tsx